import { render, staticRenderFns } from "./take_leave.vue?vue&type=template&id=0b93d8c5&"
import script from "./take_leave.vue?vue&type=script&lang=js&"
export * from "./take_leave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports